<!--
 * @Author: 王丛
 * @Date: 2021-12-30 12:48:30
 * @LastEditTime: 2023-05-15 15:08:57
 * @Description: file content
-->
<template>
  <div class="common-title">
    <div class="title">
      {{ title }} <span>{{ subTitle }}</span>
    </div>
    <div v-if="isMore" class="more" @click="onMoreClick">
      <span>{{ moreText || '查看更多' }}</span>
      <img
        src="https://resource.chunyu.mobi/@/media/images/2021/12/28/2177/d39568ab48a7_w21_h33_.png"
        alt=""
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 标题
    title: {
      type: String,
      default: () => '',
    },
    // 副标题
    subTitle: {
      type: String,
      default: () => '',
    },
    // 是否更多展示
    isMore: {
      type: Boolean,
      default: false,
    },
    // 更多字段
    moreText: {
      type: String,
      default: () => '',
    },
  },
  methods: {
    /**
     * 点击查看更多按钮
     */
    onMoreClick() {
      this.$emit('on-more-click');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@@/styles/mixin.scss';
.common-title {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  padding: rem(10);
  .title {
    color: #323232;
    font-weight: 800;
    font-size: rem(16);
    line-height: rem(18);
    text-align: center;
    span {
      color: #999;
      font-weight: 400;
      font-size: rem(12);
      line-height: rem(14);
      letter-spacing: 0;
      text-align: right;
    }
  }
  .more {
    color: #999;
    font-size: rem(13);
    line-height: rem(15);
    letter-spacing: 0;
    text-align: right;
    img {
      width: rem(7);
      margin-left: rem(6);
    }
  }
}
</style>
